// extracted by mini-css-extract-plugin
export default {"insightSection":"SelfTestOverview_insightSection__S5mdf","spark":"SelfTestOverview_spark__JLmFx","spark__title":"SelfTestOverview_spark__title__RvH85"};